import {BrowserModule} from '@angular/platform-browser';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ToastrModule} from 'ngx-toastr';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MyWebDeskComponent} from './components/my-web-desk/my-web-desk.component';
import {MyWebDeskHeaderComponent} from './components/my-web-desk/my-web-desk-header/my-web-desk-header.component';
import {MyWebDeskContentComponent} from './components/my-web-desk/my-web-desk-content/my-web-desk-content.component';
import {MyWebDeskSidebarComponent} from './components/my-web-desk/my-web-desk-sidebar/my-web-desk-sidebar.component';
import {ContentHeaderComponent} from './components/my-web-desk/my-web-desk-content/content-header/content-header.component';
import {ContentKanbanComponent} from './components/my-web-desk/my-web-desk-content/content-kanban/content-kanban.component';
import {KanabanTaskComponent} from './components/my-web-desk/my-web-desk-content/kanaban-task/kanaban-task.component';
import {SidebarContentComponent} from './components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content.component';
import {SidebarContentNotificationCenterComponent} from './components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-notification-center/sidebar-content-notification-center.component';
import {NewTaskModalComponent} from './components/my-web-desk/new-task-modal/new-task-modal.component';
import * as $ from 'jquery';
import {DatepickerComponent} from '@common-components/datepicker/datepicker.component';

import {TabsModule} from 'ngx-bootstrap/tabs';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DragDropModule} from '@angular/cdk/drag-drop';


import {ReactiveFormsModule} from '@angular/forms';
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';

import {DatePipe} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';


import {FileUploadComponent} from './components/common-components/file-upload/file-upload.component';
import {AvatarComponent} from './components/common-components/avatar/avatar.component';
import {SidebarContentActivityCenterComponent} from './components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/sidebar-content-activity-center.component';
import {SidebarContentWatchingCenterComponent} from './components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-watching-center/sidebar-content-watching-center.component';
import {TimelineComponent} from './components/timeline/timeline.component';
import {CalendarComponent} from './components/calendar/calendar.component';
import {ViewTaskComponent} from './components/view-task/view-task.component';
import {ViewTaskTimelineComponent} from './components/common-components/view-task-timeline/view-task-timeline.component';
import {Globals} from '@app/services/globals.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {TaskMinimizedComponent} from './components/layouts/task-minimized/task-minimized.component';
import {CommentItemComponent} from './components/layouts/comment-item/comment-item.component';

import {FormsModule} from '@angular/forms';
import {ButtonDropDownComponent} from './components/common-components/button-drop-down/button-drop-down.component';


import {SelectProjectComponent} from './components/common-components/select-project/select-project.component';
import {ProjectDialogComponent} from './components/common-components/project-dialog/project-dialog.component';


import {SearchPipePipe} from './search-pipe.pipe';
import {FilePreviewModalComponent} from './components/common-components/file-preview-modal/file-preview-modal.component';
import {BsDatepickerComponent} from './components/common-components/bs-datepicker/bs-datepicker.component';
import {NewActivityModalComponent} from './components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/new-activity-modal/new-activity-modal.component';

import {ChooseTagsComponent} from '@common-components/choose-tags/choose-tags.component';

import {DateRangePickerComponent} from './components/common-components/date-range-picker/date-range-picker.component';
import {DialogEstimateComponent} from './components/common-components/dialog-estimate/dialog-estimate.component';
import {FilterPipe} from './filters/filter.pipe';
import {ChooseAssignedUsersComponent} from './components/common-components/choose-assigned-users/choose-assigned-users.component';
import {AttachmentThumbnailsComponent} from './components/common-components/attachment-thumbnails/attachment-thumbnails.component';
import {CommonModule} from '@angular/common';
import {DialogConfirmComponent} from './components/common-components/dialogues/dialog-confirm/dialog-confirm.component';
import {ChooseValidatorsComponent} from './components/common-components/choose-validators/choose-validators.component';
import {NewActivityDialogComponent} from './components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/new-activity-modal/new-activity-dialog/new-activity-dialog.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {MinutesOfMeetingComponent} from './components/common-components/minutes-of-meeting/minutes-of-meeting.component';
import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import {DialogAlertComponent} from './components/view-task/dialog-alert/dialog-alert/dialog-alert.component';
import {TaskTypeComponent} from './components/common-components/task-type/task-type.component';
import {TaskTypeDialogComponent} from './components/common-components/task-type/task-type-dialog/task-type-dialog.component';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {FlatpickrModule} from 'angularx-flatpickr';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {CommentAttachmentsComponent} from './components/common-components/comment-attachments/comment-attachments.component';
import {SidebarComponent} from './components/my-web-desk/sidebar/sidebar.component';
import {NgbDateCustomParserFormatter} from "@app/date-format/dateformat";
import {FullCalendarModule} from "@fullcalendar/angular";
import {FullCalendarComponent} from "@fullcalendar/angular";


import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import {NgScrollbarModule} from "ngx-scrollbar";
import {ScrollingModule} from "@angular/cdk/scrolling";

import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {MAT_RADIO_DEFAULT_OPTIONS} from "@angular/material/radio";
import {ProjectSelectComponent} from "@common-components/project-select/project-select.component";
import {AuthGuard} from "@app/auth/auth-guard.service";
import {SprintBoardComponent} from './components/sprint/sprint-board/sprint-board.component';
import {ActiveSprintComponent} from './components/sprint/active-sprint/active-sprint.component';
import {BacklogComponent} from './components/backlog/backlog.component';
import {BacklogTaskPreviewComponent} from './components/backlog/backlog-task-preview/backlog-task-preview.component';
import {CommentsService} from "@app/services/comments/comments.service";
import {AddSprintModalComponent} from './components/sprint/add-sprint-modal/add-sprint-modal/add-sprint-modal.component';
import {ProjectsComponent} from './components/projects/projects.component';
import {BoardsComponent} from './components/boards/boards.component';
import {StatusSettingsComponent} from './components/common-components/status-settings/status-settings.component';
import {NewBoardComponent} from './components/boards/new-board/new-board.component';
import {BoardComponent} from './components/boards/board/board.component';
import {TestComponent} from './components/common-components/test/test.component';
import {BoardCardComponent} from './components/boards/board-card/board-card.component';
import {MyMaterialModule} from "../material.module";
import {AuthService} from "@app/auth/auth.service";

import {ColorPickerModule} from "ngx-color-picker";
import {ShortenTextPipe} from "@app/pipes/shorten-text/shorten-text.pipe";
import {ActiveSprintResolver} from "@components/sprint/active-sprint/active-sprint-resolver.service";

import {OdmoriComponent} from './components/odmori/odmori.component';
import {ZahtjevPregled} from './components/odmori/zahtjev-pregled/zahtjev-pregled.component';
import {KalendarOdsustva} from './components/odmori/kalendar-odustva/kalendar-odsustva.component';
import {ConfirmModal} from './components/odmori/modal/confirm/confirm.modal.controller';
import {UsedDaysModal} from './components/odmori/modal/usedDays/usedDays.modal.controller';
import {LoaderComponent} from './components/loader/loader.component';
import {PodesavanjaComponent} from './components/odmori/podesavanja/podesavanja.component';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};


const routes: Routes = [
    {path: 'home', component: MyWebDeskComponent, canActivate: [AuthGuard]},
    {path: 'timeline', component: TimelineComponent, canActivate: [AuthGuard]},
    {path: 'test', component: TestComponent},
    {path: 'calendar', component: CalendarComponent},
    {path: 'view-task/:taskId', component: ViewTaskComponent, canActivate: [AuthGuard]},
    {path: 'projects', component: ProjectsComponent, canActivate: [AuthGuard]},
    {path: 'backlog/:projectId?', component: BacklogComponent, canActivate: [AuthGuard]},
    {path: 'backlog', component: BacklogComponent, canActivate: [AuthGuard]},
    {path: 'boards/:projectId', component: BoardsComponent, canActivate: [AuthGuard]},
    {path: 'board/:boardId', component: BoardComponent, canActivate: [AuthGuard]},
    {path: 'active-sprint', component: ActiveSprintComponent, canActivate: [AuthGuard], resolve: {data: ActiveSprintResolver}},
    {path: 'odmori', component: OdmoriComponent},
    {path: 'zahtjev-pregled/:reqId', component: ZahtjevPregled},
    {path: 'kalendar-odsustva', component: KalendarOdsustva},
    {path: 'podesavanja', component: PodesavanjaComponent},
    {path: '', redirectTo: 'home', pathMatch: 'full'}
];


@NgModule({
    declarations: [
        AppComponent,
        MyWebDeskComponent,
        MyWebDeskHeaderComponent,
        MyWebDeskContentComponent,
        MyWebDeskSidebarComponent,
        ContentHeaderComponent,
        ContentKanbanComponent,
        KanabanTaskComponent,
        SidebarContentComponent,
        SidebarContentNotificationCenterComponent,
        NewTaskModalComponent,
        DatepickerComponent,
        FileUploadComponent,
        AvatarComponent,
        SidebarContentActivityCenterComponent,
        SidebarContentWatchingCenterComponent,
        TimelineComponent,
        CalendarComponent,
        ViewTaskComponent,
        ViewTaskTimelineComponent,
        TaskMinimizedComponent,
        CommentItemComponent,
        ButtonDropDownComponent,
        SelectProjectComponent,
        ProjectDialogComponent,
        ChooseTagsComponent,
        SearchPipePipe,
        FilePreviewModalComponent,
        BsDatepickerComponent,
        NewActivityModalComponent,
        DateRangePickerComponent,
        DialogEstimateComponent,
        FilterPipe,
        ChooseAssignedUsersComponent,
        AttachmentThumbnailsComponent,
        DialogConfirmComponent,
        ChooseValidatorsComponent,
        NewActivityDialogComponent,
        MinutesOfMeetingComponent,
        DialogAlertComponent,
        TaskTypeComponent,
        TaskTypeDialogComponent,
        CommentAttachmentsComponent,
        SidebarComponent,
        ProjectSelectComponent,
        SprintBoardComponent,
        ActiveSprintComponent,
        BacklogComponent,
        BacklogTaskPreviewComponent,
        AddSprintModalComponent,
        ProjectsComponent,
        BoardsComponent,
        StatusSettingsComponent,
        NewBoardComponent,
        BoardComponent,
        TestComponent,
        BoardCardComponent,
        ShortenTextPipe,
        OdmoriComponent,
        ZahtjevPregled,
        KalendarOdsustva,
        ConfirmModal,
        UsedDaysModal,
        LoaderComponent,
        PodesavanjaComponent
    ],
    entryComponents: [
        ProjectDialogComponent,
        DialogEstimateComponent
    ],
    imports: [
        RouterModule.forRoot(
            routes,
            {enableTracing: true} // <-- debugging purposes only
        ),
        NgbModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        TabsModule.forRoot(),
        DragDropModule,
        ToastrModule.forRoot(),
        HttpClientModule,
        BrowserAnimationsModule,
        CommonModule,
        FroalaEditorModule.forRoot(), FroalaViewModule.forRoot(),
        AngularEditorModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        FlatpickrModule,
        FlatpickrModule.forRoot(),
        NgbModalModule,
        CalendarModule.forRoot({provide: DateAdapter, useFactory: adapterFactory}),
        FullCalendarModule,
        NgScrollbarModule,
        ScrollingModule,
        PerfectScrollbarModule,
        MyMaterialModule,
        ColorPickerModule

    ],
    exports: [
        RouterModule, AppComponent],
    providers: [DatePipe, Globals, ConstantsService, AuthService, AuthGuard, CommentsService, ActiveSprintResolver, {
        provide: NgbDateParserFormatter,
        useClass: NgbDateCustomParserFormatter
    },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: {color: 'accent'},
        }],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent],
})
export class AppModule {
}
